// @ts-expect-error Legacy API helpers do not have TypeScript declarations.
import * as legacyApi from "../../../../shared/makeApiCall";
const { makeGetApiCall, makePutApiCall, makeDeleteApiCall } = legacyApi;

export type RecipeUnit = "kg" | "lbs" | "pieces";
export interface IngredientProduct {
  id: number;
  name: string;
  plu: string;
  selling_unit_of_measure: number;
}
export interface RecipeItem {
  ingredient_product_id: number;
  quantity: string;
  unit: RecipeUnit;
  ingredient: IngredientProduct | null;
  available: boolean;
}
export interface ProductRecipe {
  id: number;
  product_id: number;
  output_quantity: string;
  output_unit: RecipeUnit;
  notes: string | null;
  version: string;
  updated_at: string;
  items: RecipeItem[];
}
export interface RecipePayload {
  version: string | null;
  output_quantity: string;
  output_unit: RecipeUnit;
  notes: string;
  items: {
    ingredient_product_id: number;
    quantity: string;
    unit: RecipeUnit;
  }[];
}
export interface RecipeResponse {
  recipe: ProductRecipe | null;
  can_manage: boolean;
  product_available: boolean;
}
export class RecipeApiError extends Error {
  constructor(
    message: string,
    public status?: number,
    public fields: Record<string, string[]> = {}
  ) {
    super(message);
    this.name = "RecipeApiError";
    Object.setPrototypeOf(this, RecipeApiError.prototype);
  }
}
interface ApiResult<T> {
  success?: boolean;
  data: T & { message?: string; errors?: Record<string, string[]> };
  errorStatus?: number;
}
function unwrap<T>(result: ApiResult<T>): T {
  if (!result.success)
    throw new RecipeApiError(
      result.data?.message ||
        "Could not complete the recipe request. Try again.",
      result.errorStatus,
      result.data?.errors
    );
  return result.data;
}
export async function getRecipe(productId: number): Promise<RecipeResponse> {
  return unwrap<RecipeResponse>(
    await makeGetApiCall(`products/${productId}/recipe`)
  );
}
export async function findIngredients(
  productId: number,
  search: string
): Promise<IngredientProduct[]> {
  return unwrap<{ products: IngredientProduct[] }>(
    await makeGetApiCall(
      `products/${productId}/recipe/ingredients?search=${encodeURIComponent(
        search
      )}`
    )
  ).products;
}
export async function saveRecipe(
  productId: number,
  payload: RecipePayload
): Promise<ProductRecipe> {
  return unwrap<{ recipe: ProductRecipe }>(
    await makePutApiCall(`products/${productId}/recipe`, payload)
  ).recipe;
}
export async function removeRecipe(
  productId: number,
  version: string
): Promise<void> {
  unwrap(
    await makeDeleteApiCall(
      `products/${productId}/recipe?version=${encodeURIComponent(version)}`
    )
  );
}
